<app-capture-history-item-title>
  {{ title }}
</app-capture-history-item-title>

<app-capture-history-item-body>
  <p>
    {{ description }}
  </p>

  @if (claimType) {
    <p>
      Claim Type: {{ claimType }}
    </p>
  }

  @if (matchConfidence) {
    <p>
      Confidence Ratio: {{ matchConfidence }}
    </p>
  }
</app-capture-history-item-body>
